export const FIELD_TYPE = {
  singleSelect: 0,
  multiSelect: 1,
  rating: 2,
  text: 3
}
